import { MenuItem, MenuItemProps } from '@mui/material';
import React, { FC, useCallback, useContext } from 'react';
import { MenuContext } from './OxMenuControlled';

const SubMenuItem: FC<React.PropsWithChildren<MenuItemProps>> = props => {
  const { children, onClick, ...otherProps } = props;
  const { closeParent } = useContext(MenuContext);
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLLIElement>) => {
      closeParent();
      onClick && onClick(e);
    },
    [closeParent, onClick],
  );

  return (
    <MenuItem {...otherProps} onMouseDown={handleClick}>
      {children}
    </MenuItem>
  );
};

export default SubMenuItem;
